import React, { useContext, useEffect, useState } from "react";

import axios from "axios";

import {
  Avatar,
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Fade,
  FormControl,
  FormControlLabel,
  Grow,
  IconButton,
  InputAdornment,
  InputLabel,
  List,
  ListItem,
  ListItemIcon,
  MenuItem,
  Paper,
  Select,
  Slide,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
  Zoom,
} from "@mui/material";

import {
  AddCircleRounded,
  AdminPanelSettings as AdminIcon,
  Block as BlockIcon,
  Business as InstitutionIcon,
  Check as CheckIcon,
  Close as CloseIcon,
  Delete as DeleteIcon,
  Edit as EditIcon,
  Email as EmailIcon,
  FilterList as FilterIcon,
  ManageAccounts,
  Password as PasswordIcon,
  Person as PersonIcon,
  Search as SearchIcon,
  Visibility as VisibilityIcon,
  VisibilityOff as VisibilityOffIcon,
  Warning as WarningIcon,
  Work as AnalystIcon,
} from "@mui/icons-material";

import { api } from "@api/api";
import RegisterAnalystSRE from "../secretaria/pageServInt";
import { botaoAdicionar } from "../../estilos/botoes";

import { styled } from "@mui/material/styles";
import { keyframes } from "@emotion/react";
import { CondicaoContext } from "../../contexto";
import TransicaoPagina from "../../componentes/comuns/TransicaoPagina";

import {
  tamanhosControlesGlobais,
  tamanhosPaginasAdministrativas,
} from "../../estilos/global";

const pulse = keyframes`
  0% { transform: scale(1); }
  50% { transform: scale(1.05); }
  100% { transform: scale(1); }
`;

const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
  marginTop: theme.spacing(4),
  borderRadius: "12px",
  boxShadow: "0 8px 32px rgba(31, 38, 135, 0.15)",
  background: "linear-gradient(to bottom right, #ffffff, #f8f9fa)",
  overflow: "hidden",
  transition: "all 0.3s ease",
  "&:hover": {
    boxShadow: "0 8px 32px rgba(31, 38, 135, 0.25)",
  },
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  fontWeight: "bold",
  color: theme.palette.text.primary,
  borderBottom: `1px solid ${theme.palette.divider}`,
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:hover": {
    backgroundColor: theme.palette.action.hover,
    animation: `${pulse} 0.5s ease`,
  },
  "&:last-child td": {
    borderBottom: 0,
  },
}));

const UsuariosList = () => {
  const { role } = useContext(CondicaoContext);

  const tituloSre = role === "superintendent";

  const [cadastroAnalistaAberto, setCadastroAnalistaAberto] = useState(false);

  const [usuarios, setUsuarios] = useState([]);
  const [loading, setLoading] = useState(true);

  const [filtroRegra, setFiltroRegra] = useState("todos");
  const [termoPesquisa, setTermoPesquisa] = useState("");

  const [dialogOpen, setDialogOpen] = useState(false);
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [usuarioSelecionado, setUsuarioSelecionado] = useState(null);

  const [confirmacaoMarcada, setConfirmacaoMarcada] = useState(false);

  const [acessosUsuario, setAcessosUsuario] = useState({});

  const [nomeEditado, setNomeEditado] = useState("");
  const [emailEditado, setEmailEditado] = useState("");

  const [novaSenha, setNovaSenha] = useState("");
  const [confirmarSenha, setConfirmarSenha] = useState("");

  const [requisitosSenha, setRequisitosSenha] = useState({
    minimoCaracteres: false,
    letraMaiuscula: false,
    numero: false,
    caractereEspecial: false,
    senhasConferem: false,
  });

  const [mostrarSenha, setMostrarSenha] = useState(false);

  const [mostrarConfirmarSenha, setMostrarConfirmarSenha] = useState(false);

  // ====================================================
  // CONSULTA DOS USUÁRIOS
  // ====================================================

  useEffect(() => {
    buscarUsuarios();
  }, []);

  const buscarUsuarios = async () => {
    setLoading(true);

    try {
      const response = await axios.get(api.adminListUsers(), {
        withCredentials: true,
      });

      setUsuarios(response.data);

      const acessosIniciais = {};

      response.data.forEach((user) => {
        if (user.regra === "analyst") {
          acessosIniciais[user.id] = user.condicao === true;
        }
      });

      setAcessosUsuario(acessosIniciais);
    } catch (error) {
      console.error("Erro ao buscar usuários:", error);
    } finally {
      setLoading(false);
    }
  };

  // ====================================================
  // VALIDAÇÃO DA SENHA NA EDIÇÃO
  // ====================================================

  const validarSenha = (senha, confirmacao) => {
    const minimoCaracteres = senha.length >= 8;
    const letraMaiuscula = /[A-Z]/.test(senha);
    const numero = /[0-9]/.test(senha);

    const caractereEspecial = /[!@#$%^&*(),.?":{}|<>]/.test(senha);

    const senhasConferem = senha === confirmacao && senha !== "";

    setRequisitosSenha({
      minimoCaracteres,
      letraMaiuscula,
      numero,
      caractereEspecial,
      senhasConferem,
    });
  };

  // ====================================================
  // ACESSO À GESTÃO
  // ====================================================

  const handleAcessoUsuariosChange = async (userId, checked) => {
    try {
      setAcessosUsuario((prev) => ({
        ...prev,
        [userId]: checked,
      }));

      await axios.patch(
        api.adminUpdateUserAccess(userId),
        {
          temAcessoUsuarios: checked,
        },
        {
          withCredentials: true,
        },
      );

      buscarUsuarios();
    } catch (error) {
      console.error("Erro ao atualizar acesso:", error);

      setAcessosUsuario((prev) => ({
        ...prev,
        [userId]: !checked,
      }));
    }
  };

  // ====================================================
  // EXCLUSÃO
  // ====================================================

  const abrirDialogExclusao = (usuario) => {
    setUsuarioSelecionado(usuario);
    setDialogOpen(true);
    setConfirmacaoMarcada(false);
  };

  const confirmarExclusao = async () => {
    if (!usuarioSelecionado || !usuarioSelecionado.id) {
      return;
    }

    try {
      await axios.delete(api.adminDeleteUsers(usuarioSelecionado.id), {
        withCredentials: true,
      });

      setDialogOpen(false);
      setUsuarioSelecionado(null);
      setConfirmacaoMarcada(false);

      buscarUsuarios();
    } catch (error) {
      console.error("Erro ao excluir usuário:", error);

      if (error.response) {
        console.error("Resposta do servidor:", error.response.data);
      }
    }
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
    setConfirmacaoMarcada(false);
  };

  // ====================================================
  // EDIÇÃO
  // ====================================================

  const abrirDialogEdicao = (usuario) => {
    setUsuarioSelecionado(usuario);
    setNomeEditado(usuario.nome || "");
    setEmailEditado(usuario.email);

    setNovaSenha("");
    setConfirmarSenha("");
    setEditDialogOpen(true);

    setRequisitosSenha({
      minimoCaracteres: false,
      letraMaiuscula: false,
      numero: false,
      caractereEspecial: false,
      senhasConferem: false,
    });
  };

  const confirmarEdicao = async () => {
    if (!usuarioSelecionado || !usuarioSelecionado.id) {
      return;
    }

    if (novaSenha && novaSenha !== confirmarSenha) {
      alert("As senhas não coincidem!");
      return;
    }

    if (
      novaSenha &&
      !(
        requisitosSenha.minimoCaracteres &&
        requisitosSenha.letraMaiuscula &&
        requisitosSenha.numero &&
        requisitosSenha.caractereEspecial
      )
    ) {
      alert("A senha não atende a todos os requisitos de segurança!");
      return;
    }

    try {
      const dadosAtualizacao = {
        email: emailEditado,
      };

      if (usuarioSelecionado.regra === "analyst") {
        dadosAtualizacao.nome = nomeEditado.trim();
      }

      if (novaSenha) {
        dadosAtualizacao.senha = novaSenha;
      }

      await axios.patch(
        api.adminUpdateUser(usuarioSelecionado.id),
        dadosAtualizacao,
        {
          withCredentials: true,
        },
      );

      setEditDialogOpen(false);
      setUsuarioSelecionado(null);

      buscarUsuarios();
    } catch (error) {
      console.error("Erro ao atualizar usuário:", error);

      if (error.response) {
        console.error("Resposta do servidor:", error.response.data);
      }
    }
  };

  const handleCloseEditDialog = () => {
    setEditDialogOpen(false);
    setUsuarioSelecionado(null);
  };

  const handleSenhaChange = (e) => {
    setNovaSenha(e.target.value);

    validarSenha(e.target.value, confirmarSenha);
  };

  const handleConfirmarSenhaChange = (e) => {
    setConfirmarSenha(e.target.value);

    validarSenha(novaSenha, e.target.value);
  };

  const toggleMostrarSenha = () => {
    setMostrarSenha(!mostrarSenha);
  };

  const toggleMostrarConfirmarSenha = () => {
    setMostrarConfirmarSenha(!mostrarConfirmarSenha);
  };

  // ====================================================
  // PESQUISA E FILTRO
  // ====================================================

  const usuariosFiltrados = usuarios.filter((usuario) => {
    if (
      role === "admin" &&
      filtroRegra !== "todos" &&
      usuario.regra !== filtroRegra
    ) {
      return false;
    }

    if (termoPesquisa) {
      const termo = termoPesquisa.toLowerCase();

      return (
        usuario.nome.toLowerCase().includes(termo) ||
        usuario.email.toLowerCase().includes(termo)
      );
    }

    return true;
  });

  const getIconByRole = (roleUsuario) => {
    switch (roleUsuario) {
      case "admin":
        return <AdminIcon color="error" />;

      case "analyst":
        return <AnalystIcon color="primary" />;

      case "user":
        return <InstitutionIcon color="success" />;

      default:
        return <PersonIcon color="disabled" />;
    }
  };

  // ====================================================
  // CARREGAMENTO
  // ====================================================

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="60vh"
      >
        <Fade in={true} style={{ transitionDelay: "200ms" }}>
          <CircularProgress size={60} thickness={4} />
        </Fade>
      </Box>
    );
  }

  const pagina = (
    <Box sx={{ p: tituloSre ? 0 : 3 }}>
      {/* ====================================================
          CABEÇALHO
      ==================================================== */}

      <Grow in={true} appear={role !== "superintendent"}>
        {tituloSre ? (
          <Box
            sx={{
              display: "flex",
              alignItems: {
                xs: "stretch",
                sm: "center",
              },
              justifyContent: "space-between",
              flexDirection: {
                xs: "column",
                sm: "row",
              },
              gap: 1.5,
              mb: 1,
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1.4,
                minWidth: 0,
              }}
            >
              <Box
                sx={{
                  width: 44,
                  height: 44,
                  display: "grid",
                  placeItems: "center",
                  flexShrink: 0,
                  borderRadius: 1.5,
                  color: "#087cf0",
                  backgroundColor: "#e8f4ff",
                }}
              >
                <ManageAccounts sx={{ fontSize: 27 }} />
              </Box>

              <Box sx={{ minWidth: 0 }}>
                <Typography
                  component="h1"
                  sx={{
                    color: "#0767d8",
                    fontSize: tamanhosPaginasAdministrativas.tituloPagina,
                    fontWeight: 700,
                    lineHeight: 1.15,
                  }}
                >
                  Gerenciamento de Usuários
                </Typography>

                <Typography
                  sx={{
                    mt: 0.3,
                    color: "#7b8798",
                    fontSize: tamanhosControlesGlobais.descricao,
                    lineHeight: 1.35,
                  }}
                >
                  Consulte e gerencie os usuários do sistema.
                </Typography>
              </Box>
            </Box>

            {/* CADASTRO EXCLUSIVO DA SRE */}

            <Button
              variant="contained"
              size="small"
              startIcon={<AddCircleRounded sx={{ fontSize: 18 }} />}
              onClick={() => setCadastroAnalistaAberto(true)}
              sx={{
                ...botaoAdicionar,
                flexShrink: 0,
                alignSelf: {
                  xs: "flex-start",
                  sm: "center",
                },
              }}
            >
              Cadastrar Analista
            </Button>
          </Box>
        ) : (
          <Typography
            variant="h4"
            sx={{
              mb: 4,
              fontWeight: "bold",
              background: "linear-gradient(45deg, #1976d2, #2196f3)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            Gerenciamento de Usuários
          </Typography>
        )}
      </Grow>

      {/* ====================================================
          PESQUISA E FILTRO
      ==================================================== */}

      <Slide
        direction="down"
        in={true}
        appear={role !== "superintendent"}
        mountOnEnter
        unmountOnExit
      >
        <Box
          sx={{
            mb: 4,
            display: "flex",
            flexWrap: "wrap",
            gap: 2,
          }}
        >
          <TextField
            fullWidth
            variant="outlined"
            placeholder="Pesquisar usuários..."
            value={termoPesquisa}
            onChange={(e) => setTermoPesquisa(e.target.value)}
            InputProps={{
              startAdornment: (
                <SearchIcon
                  sx={{
                    color: "action.active",
                    mr: 1,
                  }}
                />
              ),
              sx: {
                borderRadius: "50px",
                backgroundColor: "background.paper",
                boxShadow: 1,
                fontSize:
                  role === "admin"
                    ? tamanhosControlesGlobais.campoBusca
                    : undefined,
              },
            }}
            sx={{
              flex: 1,
              minWidth: 250,
            }}
          />

          {role === "admin" && (
            <FormControl sx={{ minWidth: 200 }}>
              <InputLabel>
                <Box display="flex" alignItems="center">
                  <FilterIcon sx={{ mr: 1, fontSize: 20 }} />
                  Filtrar por Regra
                </Box>
              </InputLabel>
              <Select
                value={filtroRegra}
                onChange={(e) => setFiltroRegra(e.target.value)}
                label="Filtrar por Regra"
                sx={{
                  borderRadius: "50px",
                  backgroundColor: "background.paper",
                  boxShadow: 1,
                  fontSize:
                    role === "admin"
                      ? tamanhosControlesGlobais.seletor
                      : undefined,
                }}
              >
                <MenuItem value="todos">Todos os Usuários</MenuItem>
                <MenuItem value="analyst">Analistas</MenuItem>
                <MenuItem value="admin">Administradores</MenuItem>
                <MenuItem value="user">Instituições</MenuItem>
              </Select>
            </FormControl>
          )}
        </Box>
      </Slide>

      {/* ====================================================
          TABELA DE USUÁRIOS
      ==================================================== */}

      <Zoom
        in={true}
        appear={role !== "superintendent"}
        style={{ transitionDelay: "300ms" }}
      >
        <StyledTableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow
                sx={{
                  backgroundColor: "primary.main",
                }}
              >
                <StyledTableCell
                  sx={{
                    color: "primary.contrastText",
                  }}
                >
                  Usuário
                </StyledTableCell>

                <StyledTableCell
                  sx={{
                    color: "primary.contrastText",
                  }}
                >
                  Email
                </StyledTableCell>

                <StyledTableCell
                  sx={{
                    color: "primary.contrastText",
                  }}
                >
                  Regra
                </StyledTableCell>

                <StyledTableCell
                  sx={{
                    color: "primary.contrastText",
                  }}
                >
                  Acesso à Gestão
                </StyledTableCell>

                <StyledTableCell
                  sx={{
                    color: "primary.contrastText",
                  }}
                >
                  Ações
                </StyledTableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {usuariosFiltrados.length > 0 ? (
                usuariosFiltrados.map((usuario) => (
                  <StyledTableRow key={usuario.id} hover>
                    <TableCell>
                      <Box display="flex" alignItems="center">
                        <Avatar
                          sx={{
                            mr: 2,
                            bgcolor: "primary.main",
                          }}
                        >
                          {usuario.nome.charAt(0).toUpperCase()}
                        </Avatar>

                        {usuario.nome}
                      </Box>
                    </TableCell>

                    <TableCell>{usuario.email}</TableCell>

                    <TableCell>
                      <Box display="flex" alignItems="center">
                        {getIconByRole(usuario.regra)}

                        <Typography
                          variant="body2"
                          sx={{
                            ml: 1,
                            fontSize:
                              role === "admin"
                                ? tamanhosPaginasAdministrativas.conteudoTabela
                                : undefined,
                          }}
                        >
                          {usuario.regra === "admin" && "Administrador"}

                          {usuario.regra === "analyst" && "Analista"}

                          {usuario.regra === "user" && "Instituição"}
                        </Typography>
                      </Box>
                    </TableCell>

                    <TableCell>
                      {usuario.regra === "analyst" ? (
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={acessosUsuario[usuario.id] || false}
                              onChange={(e) =>
                                handleAcessoUsuariosChange(
                                  usuario.id,
                                  e.target.checked,
                                )
                              }
                              color="primary"
                            />
                          }
                          label="Acesso à gestão"
                          sx={{
                            "& .MuiFormControlLabel-label": {
                              fontSize:
                                role === "admin"
                                  ? tamanhosPaginasAdministrativas.conteudoTabela
                                  : undefined,
                            },
                          }}
                        />
                      ) : (
                        <Tooltip title="Disponível apenas para analistas">
                          <Box
                            sx={{
                              color: "text.disabled",
                              fontStyle: "italic",
                            }}
                          >
                            Não aplicável
                          </Box>
                        </Tooltip>
                      )}
                    </TableCell>

                    <TableCell>
                      <Box display="flex" gap={1}>
                        <Tooltip title="Editar usuário">
                          <IconButton
                            color="primary"
                            onClick={() => abrirDialogEdicao(usuario)}
                          >
                            <EditIcon />
                          </IconButton>
                        </Tooltip>

                        {usuario.regra !== "user" && (
                          <Tooltip title="Excluir usuário">
                            <IconButton
                              color="error"
                              onClick={() => abrirDialogExclusao(usuario)}
                            >
                              <DeleteIcon />
                            </IconButton>
                          </Tooltip>
                        )}

                        {usuario.regra === "user" && (
                          <Tooltip title="Instituições não podem ser excluídas">
                            <IconButton
                              disabled
                              sx={{
                                color: "text.disabled",
                              }}
                            >
                              <BlockIcon />
                            </IconButton>
                          </Tooltip>
                        )}
                      </Box>
                    </TableCell>
                  </StyledTableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={5} align="center" sx={{ py: 4 }}>
                    <Typography
                      variant="body1"
                      color="textSecondary"
                      sx={{
                        fontSize:
                          role === "admin"
                            ? tamanhosControlesGlobais.descricao
                            : undefined,
                      }}
                    >
                      Nenhum usuário encontrado
                    </Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </StyledTableContainer>
      </Zoom>

      {/* ====================================================
          CADASTRO DE ANALISTA
      ==================================================== */}

      {tituloSre && cadastroAnalistaAberto && (
        <RegisterAnalystSRE
          emModal
          onCancelar={() => setCadastroAnalistaAberto(false)}
          onCadastrado={() => {
            setCadastroAnalistaAberto(false);
            buscarUsuarios();
          }}
        />
      )}

      {/* ====================================================
          CONFIRMAÇÃO DE EXCLUSÃO
      ==================================================== */}

      <Dialog
        open={dialogOpen}
        onClose={handleCloseDialog}
        TransitionComponent={Slide}
        transitionDuration={300}
      >
        <DialogTitle
          sx={{
            bgcolor: "error.main",
            color: "error.contrastText",
            display: "flex",
            alignItems: "center",
          }}
        >
          <WarningIcon
            sx={{
              mr: 10,
              mt: 1,
            }}
          />
          Confirmar Exclusão
        </DialogTitle>

        <DialogContent sx={{ p: 3 }}>
          <Box display="flex" alignItems="center" mt={6} mb={2}>
            <Avatar
              sx={{
                bgcolor: "error.main",
                mr: 2,
              }}
            >
              <DeleteIcon />
            </Avatar>

            <Typography variant="body1">
              Você está prestes a excluir permanentemente o usuário:
            </Typography>
          </Box>

          <Box pl={7} mb={2}>
            <Typography variant="h6" gutterBottom>
              <strong>{usuarioSelecionado?.nome}</strong>
            </Typography>

            <Typography variant="body2" color="textSecondary">
              {usuarioSelecionado?.email}
            </Typography>

            <Typography variant="caption" color="error" display="block" mt={1}>
              Esta ação não pode ser desfeita!
            </Typography>
          </Box>

          <FormControlLabel
            control={
              <Checkbox
                checked={confirmacaoMarcada}
                onChange={(e) => setConfirmacaoMarcada(e.target.checked)}
                color="error"
              />
            }
            label="Eu entendo que esta ação é irreversível e desejo prosseguir"
            sx={{ ml: 0 }}
          />
        </DialogContent>

        <DialogActions sx={{ p: 2 }}>
          <Button
            onClick={handleCloseDialog}
            variant="outlined"
            sx={{
              borderRadius: "50px",
            }}
          >
            Cancelar
          </Button>

          <Button
            color="error"
            onClick={confirmarExclusao}
            variant="contained"
            startIcon={<DeleteIcon />}
            sx={{
              borderRadius: "50px",
            }}
            disabled={!confirmacaoMarcada}
          >
            Confirmar Exclusão
          </Button>
        </DialogActions>
      </Dialog>

      {/* ====================================================
          EDIÇÃO DE USUÁRIO
      ==================================================== */}

      <Dialog
        open={editDialogOpen}
        onClose={handleCloseEditDialog}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle
          sx={{
            bgcolor: "primary.main",
            color: "primary.contrastText",
            display: "flex",
            alignItems: "center",
          }}
        >
          <EditIcon sx={{ mr: 1 }} />
          Editar Usuário
        </DialogTitle>

        <DialogContent sx={{ p: 3 }}>
          <Box mb={3}>
            <Box display="flex" alignItems="center" mb={2}>
              <Avatar
                sx={{
                  bgcolor: "primary.main",
                  mr: 2,
                }}
              >
                {usuarioSelecionado?.nome?.charAt(0).toUpperCase()}
              </Avatar>

              {usuarioSelecionado?.regra === "analyst" ? (
                <TextField
                  fullWidth
                  label="Nome do Analista"
                  variant="standard"
                  value={nomeEditado}
                  onChange={(e) => setNomeEditado(e.target.value)}
                  sx={{ flex: 1 }}
                />
              ) : (
                <Typography variant="h6">{usuarioSelecionado?.nome}</Typography>
              )}
            </Box>

            <TextField
              fullWidth
              label="Email"
              variant="outlined"
              value={emailEditado}
              onChange={(e) => setEmailEditado(e.target.value)}
              InputProps={{
                startAdornment: (
                  <EmailIcon
                    sx={{
                      color: "action.active",
                      mr: 1,
                    }}
                  />
                ),
              }}
              sx={{ mb: 3 }}
            />

            <Typography variant="subtitle1" gutterBottom sx={{ mt: 2 }}>
              Alterar Senha
            </Typography>

            <DialogContentText sx={{ mb: 2 }}>
              Deixe em branco para manter a senha atual
            </DialogContentText>

            <TextField
              fullWidth
              label="Nova Senha"
              type={mostrarSenha ? "text" : "password"}
              variant="outlined"
              value={novaSenha}
              onChange={handleSenhaChange}
              InputProps={{
                startAdornment: (
                  <PasswordIcon
                    sx={{
                      color: "action.active",
                      mr: 1,
                    }}
                  />
                ),
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={toggleMostrarSenha} edge="end">
                      {mostrarSenha ? (
                        <VisibilityOffIcon />
                      ) : (
                        <VisibilityIcon />
                      )}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              sx={{ mb: 2 }}
            />

            <TextField
              fullWidth
              label="Confirmar Senha"
              type={mostrarConfirmarSenha ? "text" : "password"}
              variant="outlined"
              value={confirmarSenha}
              onChange={handleConfirmarSenhaChange}
              InputProps={{
                startAdornment: (
                  <PasswordIcon
                    sx={{
                      color: "action.active",
                      mr: 1,
                    }}
                  />
                ),
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={toggleMostrarConfirmarSenha}
                      edge="end"
                    >
                      {mostrarConfirmarSenha ? (
                        <VisibilityOffIcon />
                      ) : (
                        <VisibilityIcon />
                      )}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />

            {novaSenha && (
              <Box mt={2}>
                <Typography variant="subtitle2">
                  Requisitos da senha:
                </Typography>

                <List dense>
                  <ListItem>
                    <ListItemIcon>
                      {requisitosSenha.minimoCaracteres ? (
                        <CheckIcon color="success" />
                      ) : (
                        <CloseIcon color="error" />
                      )}
                    </ListItemIcon>

                    <Typography variant="body2">
                      Mínimo de 8 caracteres
                    </Typography>
                  </ListItem>

                  <ListItem>
                    <ListItemIcon>
                      {requisitosSenha.letraMaiuscula ? (
                        <CheckIcon color="success" />
                      ) : (
                        <CloseIcon color="error" />
                      )}
                    </ListItemIcon>

                    <Typography variant="body2">
                      Pelo menos 1 letra maiúscula
                    </Typography>
                  </ListItem>

                  <ListItem>
                    <ListItemIcon>
                      {requisitosSenha.numero ? (
                        <CheckIcon color="success" />
                      ) : (
                        <CloseIcon color="error" />
                      )}
                    </ListItemIcon>

                    <Typography variant="body2">Pelo menos 1 número</Typography>
                  </ListItem>

                  <ListItem>
                    <ListItemIcon>
                      {requisitosSenha.caractereEspecial ? (
                        <CheckIcon color="success" />
                      ) : (
                        <CloseIcon color="error" />
                      )}
                    </ListItemIcon>

                    <Typography variant="body2">
                      Pelo menos 1 caractere especial (!@#$%^&*)
                    </Typography>
                  </ListItem>

                  <ListItem>
                    <ListItemIcon>
                      {requisitosSenha.senhasConferem ? (
                        <CheckIcon color="success" />
                      ) : (
                        <CloseIcon color="error" />
                      )}
                    </ListItemIcon>

                    <Typography variant="body2">As senhas coincidem</Typography>
                  </ListItem>
                </List>
              </Box>
            )}
          </Box>
        </DialogContent>

        <DialogActions sx={{ p: 2 }}>
          <Button
            onClick={handleCloseEditDialog}
            variant="outlined"
            sx={{
              borderRadius: "50px",
            }}
          >
            Cancelar
          </Button>

          <Button
            color="primary"
            onClick={confirmarEdicao}
            variant="contained"
            startIcon={<EditIcon />}
            sx={{
              borderRadius: "50px",
            }}
            disabled={
              novaSenha &&
              !(
                requisitosSenha.minimoCaracteres &&
                requisitosSenha.letraMaiuscula &&
                requisitosSenha.numero &&
                requisitosSenha.caractereEspecial &&
                requisitosSenha.senhasConferem
              )
            }
          >
            Salvar Alterações
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );

  return tituloSre ? (
    <TransicaoPagina variante="navegacao">{pagina}</TransicaoPagina>
  ) : (
    pagina
  );
};

export default UsuariosList;
